import axios from 'axios';
import Common from './Common';
export default {
    getStatus(id) {
        return axios.get(Common.api + 'open/' + id);
    },
    openMessageStatus(id, i) {
        return axios.get(Common.api + 'open-msg/' + id + '/' + i);
    },
    getAll(id) {
        return axios.get(Common.api + 'unread-notification-count/' + id);
    },
    getAllMessage(id) {
        return axios.get(Common.api + 'get-unread-chat-count/' + id);
    },
    getStatusCheck(id, i) {
        return axios.get(Common.api + 'get-thread-unopened/' + id + '/' + i);
    },
    getSystemNotification(id, i) {
        return axios.get(Common.api + 'make-system-notification/' + id + '/' + i);
    },
    getPurchaseNotification(id, i) {
        return axios.get(Common.api + 'purchase-notification/' + id + '/' + i);
    },
    getRequestReceiveNotification(id, i) {
        return axios.get(Common.api + 'notify-request-receive/' + id + '/' + i);
    },
    // getRequestAcceptanceNotification(id, i) {
    //     return axios.get(Common.api + 'notify-request-acceptance/' + id + '/' + i);
    // },
    getRequestDeclineNotification(id, i) {
        return axios.get(Common.api + 'notify-request-decline/' + id + '/' + i);
    },
    getResponseAcceptanceNotification(id, i) {
        return axios.get(Common.api + 'notify-response-acceptance/' + id + '/' + i);
    },
    getServiceDeliveryNotification(id, i) {
        return axios.get(Common.api + 'notify-service-delivery/' + id + '/' + i);
    },
    getRecruitmentExpiredNotification(id, i) {
        return axios.get(Common.api + 'recruitment-expired/' + id + '/' + i);
    },
    getFollowingNotification(id, i) {
        return axios.get(Common.api + 'following/' + id + '/' + i);
    },
    getEstimationNotification(id, i) {
        return axios.get(Common.api + 'estimation-asked/' + id + '/' + i);
    },

}